export default "__VITE_ASSET__S10dMV$k__"